import { demoNorthfield } from './demo-northfield'
import type { TenantFixture } from './types'

/**
 * A demo business with no name. The real API's client falls back to this for
 * figures no endpoint serves yet, and those figures appear under whichever
 * tenant is signed in — so the text generated from them ("Demo organisation
 * took £…") must never read as a real customer's.
 */
export const neutralDemo: TenantFixture = {
  ...demoNorthfield,
  id: 'demo_neutral',
  name: 'Demo organisation',
  accentColor: null,
  user: { name: 'Demo user', email: 'demo@example.com', role: 'owner' },
  websites: [{ id: 'web_demo', name: 'demo.example', environment: 'production', trafficShare: 1 }],
}
